var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',{staticClass:"text-h6 text-center"},[_vm._v("Testing With Tommy")]),_c('p',[_vm._v("When we next encounter P, he’s taking Nico’s advice about talking to Tommy...")])])}
var staticRenderFns = []

export { render, staticRenderFns }